import { AppRecord } from '$tablet-app/src/app/app_library/types';
import PopUpMenu from '$tablet-app/src/app/components/PopUpMenu';
import Spacer from '$tablet-app/src/app/components/Spacer';
import Text from '$tablet-app/src/app/components/Text';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React, { FC } from 'react';
import { TouchableOpacity } from 'react-native';
import styled from 'styled-components/native';

interface Props {
  app: AppRecord;
  label?: React.ReactElement;
  onPress?: (app: AppRecord) => void;
  onPressUninstall?: (app: AppRecord) => void;
}

const AppSelectionItem: FC<Props> = (props) => {
  const { app, onPress } = props;

  const handleOnPress = () => onPress?.(app);

  return (
    <PopUpMenu
      anchor={({ showPopUp }) => (
        <Container onPress={handleOnPress} onLongPress={showPopUp}>
          {app.icon ? (
            <Image source={{ uri: 'data:image/png;base64,' + app.icon }} />
          ) : (
            <Placeholder />
          )}
          <Spacer height="16px" />
          {props.label ? (
            props.label
          ) : (
            <Label variant="caption" weight="semibold">
              {app.label}
            </Label>
          )}
        </Container>
      )}
    >
      {({ hidePopUp }) => (
        <AppMenu
          app={app}
          onPressUninstall={(app) => {
            hidePopUp();
            props.onPressUninstall?.(app);
          }}
        />
      )}
    </PopUpMenu>
  );
};

const AppMenu = (props: {
  app: AppRecord;
  onPressUninstall?: (app: AppRecord) => void;
}) => {
  const onPressUninstall = () => props.onPressUninstall?.(props.app);

  return (
    <MenuItem onPress={onPressUninstall}>
      <FontAwesomeIcon icon="trash" />
      <Spacer width="16px" />
      <Text>Uninstall</Text>
    </MenuItem>
  );
};

const Container = styled.TouchableOpacity`
  align-items: center;
`;

const Image = styled.Image`
  height: 86px;
  width: 86px;
`;

const Placeholder = styled.View`
  height: 86px;
  width: 86px;
  border-radius: 4px;
`;

const Label = styled(Text)`
  color: white;
`;

const MenuItem = styled(TouchableOpacity)`
  flex-direction: row;
  align-items: center;
  padding: 16px;
`;

export default AppSelectionItem;
